import styled from 'styled-components';

export const TitleLabel = styled.div`
  padding-bottom: 10px;
`;